
type Ouvinte = () => void;

const ouvintes = new Set<Ouvinte>();

export const avisarBloqueioAtualizacaoCadastral = () => {
  ouvintes.forEach((ouvinte) => ouvinte());
};

/** @return funcao que cancela a inscricao */
export const ouvirBloqueioAtualizacaoCadastral = (ouvinte: Ouvinte) => {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
};
